import {EtsyBulkCreateCsvData} from './getEtsyBulkCreateCsvHeader';

export default function mapCsvToCreateEtsyListing(data: EtsyBulkCreateCsvData) {
  return {
    title: data.title,
    sku: data.sku,
    tags: Object.entries(data)
      .filter(([key]) => key.startsWith('tag') && data[key as keyof EtsyBulkCreateCsvData])
      .map(([_, value]) => value as string),
    images: Object.entries(data)
      .filter(([key]) => key.startsWith('image_url_') && data[key as keyof EtsyBulkCreateCsvData])
      .map(([_, value]) => value as string),
  };
}
